import isEmpty from 'lodash-es/isEmpty'
import * as Yup from 'yup'

import { EMPTY_OBJECT } from '../../../constants/common'
import { getItemsIds } from '../../../utils/common'
import { getCleanValues } from '../../../utils/formHelpers'
import { parseServerValidation } from '../../../utils/validation'
import {
  LABEL_PRIVACY_VALUE_PRIVATE,
  LABEL_PRIVACY_VALUE_PUBLIC,
} from '../Label.constants'
import { mapLabelEntityApiValueToFormValue } from '../Label.utils'

import {
  INITIAL_VALUES,
  LABEL_FIELD_NAME_PRIVACY,
  LABEL_FORM_FIELD_NAME_COLOR,
  LABEL_FORM_FIELD_NAME_ENTITY,
  LABEL_FORM_FIELD_NAME_TITLE,
} from './LabelForm.constants'

function normalizeLabelPrivacyValue(value) {
  return value?.trim().toLowerCase()
}

export function getPrivacyFieldPublicOption(t) {
  return {
    label: t('Label.PrivacyFieldPublicOptionKey'),
    value: LABEL_PRIVACY_VALUE_PUBLIC,
  }
}

export function getPrivacyFieldPrivateOption(t) {
  return {
    label: t('Label.PrivacyFieldPrivateOptionKey'),
    value: LABEL_PRIVACY_VALUE_PRIVATE,
  }
}

export function getInitialValues(initValues, t) {
  const privacyNorm = normalizeLabelPrivacyValue(initValues?.privacy)
  const privacyOption =
    privacyNorm === LABEL_PRIVACY_VALUE_PUBLIC
      ? getPrivacyFieldPublicOption(t)
      : getPrivacyFieldPrivateOption(t)

  return {
    ...INITIAL_VALUES,
    ...initValues,
    [LABEL_FIELD_NAME_PRIVACY]: privacyOption,
    [LABEL_FORM_FIELD_NAME_ENTITY]:
      initValues?.entities?.map(entityValue =>
        mapLabelEntityApiValueToFormValue(entityValue, t)
      ) ||
      initValues?.[LABEL_FORM_FIELD_NAME_ENTITY] ||
      INITIAL_VALUES[LABEL_FORM_FIELD_NAME_ENTITY],
  }
}

export function getValidationSchema() {
  return Yup.object({
    [LABEL_FIELD_NAME_PRIVACY]: Yup.object({
      value: Yup.string().trim().required(true),
    })
      .nullable()
      .required(true),
    [LABEL_FORM_FIELD_NAME_COLOR]: Yup.string().trim().required(true),
    [LABEL_FORM_FIELD_NAME_ENTITY]: Yup.array()
      .of(Yup.object())
      .min(1, true)
      .required(true),
    [LABEL_FORM_FIELD_NAME_TITLE]: Yup.string().trim().required(true),
  })
}

export function applyServerValidationErrors(error, setErrors) {
  const errors = error?.response?.data ?? EMPTY_OBJECT

  if (!isEmpty(errors)) {
    setErrors(parseServerValidation(errors))
  }
}

export function getPayload(values) {
  const payload = getCleanValues(values)

  const entities =
    payload[LABEL_FORM_FIELD_NAME_ENTITY]?.length > 0
      ? getItemsIds(payload[LABEL_FORM_FIELD_NAME_ENTITY], 'value')
      : undefined

  const privacyNorm = normalizeLabelPrivacyValue(
    payload[LABEL_FIELD_NAME_PRIVACY]?.value
  )

  return {
    ...(privacyNorm === LABEL_PRIVACY_VALUE_PUBLIC ||
    privacyNorm === LABEL_PRIVACY_VALUE_PRIVATE
      ? { public: privacyNorm === LABEL_PRIVACY_VALUE_PUBLIC }
      : null),
    ...(entities ? { entities } : null),
    color: payload[LABEL_FORM_FIELD_NAME_COLOR],
    name: payload[LABEL_FORM_FIELD_NAME_TITLE],
  }
}
